import { DetailedHTMLProps, HTMLAttributes } from 'react'
import cn from 'clsx'
import s from './styles.module.scss'

export const PaddingContainer = ({
  className,
  children,
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
  return (
    <div {...props} className={cn(s.container, className)}>
      {children}
    </div>
  )
}
